// extracted by mini-css-extract-plugin
module.exports = {"dialog_items":"DialogItems_dialog_items__1KZrN"};